export const FORM_NAMES = {
  MONEY_TRANSFER: "moneytransfer",
  CASH_PICKUP: "cashpickup",
  ACCOUNT: {
    ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
    COMMUNICATION_PREFERENCES: 'COMMUNICATION_PREFERENCES',
    ACTIVATE_REPLACEMENT_CARD: 'ACTIVATE_REPLACEMENT_FORM'
  },
  ODT: {
    AMOUNT_PURPOSE: 'odt-amount-purpose',
  },
  BANK_ACCOUNTS: "bank-account-flow",
  PAYMENT_DISBURSEMENT_HISTORY: "payment-disbursement-history",
  WU_2_ACCOUNT: "wu-2-account",
  ACTIVATE_CARD: "activate-card",
};

export const ASCII = {
  DOT: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  RETURN: 13,
};

export const DOCUMENT_NUMBER = {
  MODAL_TITLE: "Document Number Information",
  MODAL_CONTENT: "<p>In this field please provide your passport number or your U.S. social security number.</p>"
}

export const PAYMENT_DISBURSEMENT_HISTORY_FORM = {
  START_DATE: {
    FIELD_NAME: "startDate",
    LABEL: "Start Date",
  },
  END_DATE: {
    FIELD_NAME: "endDate",
    LABEL: "End Date",
  },
  BENEFICIARY_NAME: {
    FIELD_NAME: "beneficiaryName",
    LABEL: "Beneficiary Name",
    SELECT_FIELD_NAME: "beneficiaryNameFilterBy",
  },
  SHOW_DISBURSEMENTS: {
    FIELD_NAME: "showDisbursements",
    LABEL: "Show Disbursements",
  },
  PAGE_SIZE: {
    FIELD_NAME: "pageSize",
    LABEL: "Number Per Page",
  },
}

export const ACTIVATE_CARD_FORM = {
  CARD_NUMBER: {
    FIELD_NAME: "CardNumber",
    LABEL: "Brightwell card number",
  },
  CONFIRM_CARD_NUMBER: {
    FIELD_NAME: "confirmCardNumber",
    LABEL: "Confirm card number",
  },
  EXPIRATION_DATE: {
    FIELD_NAME: "expDate",
    LABEL: "Expiration date",
  },
  CREATE_PIN: {
    FIELD_NAME: "PinNumber",
    LABEL: "Create PIN",
  },
  CONFIRM_PIN: {
    FIELD_NAME: "confirmPin",
    LABEL: "Confirm PIN",
  },

}